export const dataHooks = {
  title: 'sidebarheadernext-title',
  subtitle: 'sidebarheadernext-subtitle',
};
